export default __webpack_public_path__ + "static/media/Lyuk_yigish1.e2cdae1c.png";